import { getCookie } from '../utils/cookie';

import request, { apiURL } from '../utils/api';
class AffordableRelationshipService {
  getAll() {
    const options = {
      headers: {
        Authorization: getCookie('session_id'),
        'Content-Type': 'application/json',
      },
    };
    return request(`${apiURL}/affordable-relationships`, options);
  }
}

export default AffordableRelationshipService;
